import { Injectable, ViewContainerRef } from '@angular/core';
import { Headers, Http, Response, URLSearchParams } from '@angular/http';
import { SettingsEntry } from './settings-entry';
import { ErrorHandler } from '../../restapi/error-handler';
import { UserService } from '../../user/user.service';
import { AwsHttp } from '../../aws/http';


@Injectable()
export class PythonApiEntry implements SettingsEntry {
    label: string;

    constructor(private http: Http, private errorHandler: ErrorHandler, private userService: UserService, private awsHTTP: AwsHttp) {
        this.label = 'Python API Client';
    }

    activate(viewContainerRef: ViewContainerRef) {
        let url = window.location.protocol + '//' + window.location.hostname + ':' +
                window.location.port + '/python-api/bpcddos.zip';
        window.open(url);

        //let headers = new Headers({
        //    'Content-Type': 'application/zip'
        //});

        //this.http.get(url, {headers: headers})
        //  .subscribe( (response: any) => {
        //       var file = new Blob([response], {type: 'application/zip'});
        //       var fileURL = URL.createObjectURL(file);
        //       window.open(url);
        //});
    }

    clean() { }

}



// WEBPACK FOOTER //
// ./src/app/headerfooter/setting-entries/python-api-entry.ts